<template>
  <div class="detailswelfare-box">
    <van-sticky>
      <div class="top-box">
        <p v-if="state.subNameList.length == 0">请先创建游戏小号再领取礼包</p>
        <p v-else>{{ state.selectedItem.nickname }}</p>
        <p v-if="state.subNameList.length > 0" @click="switchXiaoHao()">切换</p>
      </div>
    </van-sticky>
    <!-- 分页------------------------------优惠券 -->

    <van-pull-refresh
      v-model="state.refreshing"
      class="coupon-refresh"
      @refresh="onRefresh"
    >
    <div v-if="state.show_sdkyk" @click="goMonthCard" class="coupon-yk">
      <img v-if="!state.user_yk" src="../../../assets/coupon/coupon_yk_bg.webp" alt="" />
      <img v-else src="../../../assets/coupon/coupon_yk_bg2.webp" alt="" />
    </div>

    <div class="coupon-fuliguan" v-if="state.url_fuliguan" @click="goUrl(state.url_fuliguan)">
      <img src="../../../assets/coupon/ic_game_fuliguan.png" alt="">
    </div>

      <!-- 分页------------------------------优惠券 -->
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
      <van-cell
          v-for="(item, i) in state.coupons"
          :key="'coupon-' + item.cid + '-' + i"
          :border="false"
        >
          <template #value>
            <div class="coupon-card" :class="{ split: item.is_split == 1 }">
              <div class="left">
                <p><span>¥</span>{{ item.coupon_money }}</p>
                <p v-if="item.is_split == 1">无门槛代金券</p>
                <p v-else>满{{ item.pay_money }}可用</p>
                <div class="tips" v-if="item.type == 4">无限领取</div>
                <div class="tips" v-else-if="item.type == 3">每周领取</div>
                <div class="tips" v-else-if="item.type == 2">每天领取</div>
              </div>
              <div class="right">
                <div>
                  <p>
                    {{ item.name }}
                    <img
                      class="tipimg"
                      v-if="item.is_split == 1"
                      src="../../../assets/personal/ic_arrow_tip.png"
                      alt=""
                      @click="openTips"
                    />
                  </p>
                  <p>
                    <span style="color: #666">适用于</span>{{ item.gamename }}
                  </p>
                  <p>
                    {{ item.time }}
                  </p>
                </div>
                <div>
                  <div
                    class="cardbtnnor"
                    v-if="item.is_get == '0' || item.type == 4"
                    @click="receiveCoupon(item)"
                  >
                    领取
                  </div>
                  <div class="cardbtngray" v-else>已领取</div>
                </div>
              </div>
            </div>
          </template>
        </van-cell>

        <div class="coupon-title" v-if="state.flashCoupons.length > 0">
          - 福利券每日10:00/18:00更新 -
        </div>
        <van-cell
          v-for="(item, i) in state.flashCoupons"
          :key="'flash-' + item.activity_id + '-' + i"
          :border="false"
        >
          <template #value>
            <div class="coupon-card" :class="{ split: item.is_split == 1 }">
              <div class="left">
                <p><span>¥</span>{{ item.coupon_money }}</p>
                <p v-if="item.is_split == 1">无门槛代金券</p>
                <p v-else>满{{ item.pay_money }}可用</p>
                <div class="tips" >福利券</div>
                <div class="tips" v-if="item.type == 4">无限领取</div>
                <div class="tips" v-else-if="item.type == 3">每周领取</div>
                <div class="tips" v-else-if="item.type == 2">每天领取</div>
              </div>
              <div class="right">
                <div>
                  <p>
                    {{ item.name }}
                    <img
                      class="tipimg"
                      v-if="item.is_split == 1"
                      src="../../../assets/personal/ic_arrow_tip.png"
                      alt=""
                      @click="openTips"
                    />
                  </p>
                  <p>
                    <span style="color: #666">{{ item.desc }}</span>
                  </p>
                  <p>
                    {{ item.time }}
                  </p>
                </div>
                <div>
                  <div
                    class="cardbtnnor"
                    v-if="canReceiveFlashCoupon(item)"
                    @click="receiveFlashCoupon(item)"
                  >
                    领取
                  </div>
                  <div class="cardbtngray" v-else>
                    {{ flashCouponButtonText(item) }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </van-cell>
        
      </van-list>
    </van-pull-refresh>

    <van-popup v-model:show="state.show">
      <div class="popup-box">
        <h3>请选择领取小号</h3>

        <div
          class="subname-item"
          v-for="(item, i) in state.subNameList"
          :key="i + '-subNameList'"
          @click="onXiaoHaoSelected(i)"
        >
          <p>{{ item.nickname }}</p>
          <img
            v-if="item.status == '1'"
            src="../../../assets/game/yz_xq_gift_xh_xz1.png"
          />
          <img v-else src="../../../assets/game/yz_xq_gift_xh_xz2.png" />
        </div>

        <div class="btn-box">
          <p @click="onCancel()">取消</p>
          <p @click="onSure()">确定</p>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model:show="state.showTips"
      position="bottom"
      round
      :style="{ height: 'auto' }"
    >
      <div class="splitTips">
        <h3>优惠券说明</h3>
        <div>
          可拆分特殊优惠券，在游戏内充值使用:
          <p>1.游戏内充值时消耗该优惠券余额抵扣;</p>
          <p>2.不能和其他优惠券叠加使用;</p>
          <p>3.游戏中使用,无门槛限制,直到余额抵扣完为止。</p>
        </div>
        <button @click="state.showTips = false">我知道了</button>
      </div>
    </van-popup>

    <!-- 缺失页 -->
    <div v-show="state.missPageFlag" class="missPage">
      <img src="../../../assets/game/yz_misspage_sc.png" alt="" />
      <p>暂无优惠券</p>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, onDeactivated, onActivated } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast } from "vant";
import { gameDeduction, xiaohaolist } from "@/api/gameindex";
import { couponFlashLists, getcoupon, getCouponFlash } from "@/api/coupon";
import { useStore } from "vuex";
import { detect } from "@/utils/device";
import defaultimg1 from "@/assets/defaultimg/error2.png";

import dayjs from "dayjs";
import { getQueryString } from "@/utils/location";
import { stat } from "fs";
import { on } from "events";
export default {
  name: "game-deduction",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      noimg: defaultimg1,
      show: false,
      on: "1",
      coupons: [],
      flashCoupons: [],
      subNameList: [],
      selectedItem: {},
      tempPosition: 0,
      oldId: "",
      missPageFlag: false,
      loading: false,
      finished: false,
      showTips: false,
      refreshing: false,
      show_sdkyk: false,
      user_yk: false,
      url_fuliguan: "",
    });

    const gettime = (time) => {
      return dayjs(time).format("MM-DD HH:mm");
    };

    onMounted(() => {
      window.scrollTo(0, 0);
    });

    // 返回
    const onClickLeft = () => {
      router.back();
    };

    // 领券
        let fetchFlag = false;
    const receiveCoupon = (item) => {
      if (!state.selectedItem.username) {
        Toast("未选择小号");
        return;
      }
      // if (store.state.token) {
      if (fetchFlag) return;
        fetchFlag = true;
      getcoupon({
        cid: item.cid,
        // uid: localStorage.getItem("uid"),
        uid: getQueryString("uid"),
        xiaohao: state.selectedItem.username,
      })
          .then((response) => {
            Toast(response.data.msg);
            item.is_get = "1";
          })
          .catch((error) => {
            Toast(error?.response?.data?.msg || "领取失败，请稍后重试");
          })
          .finally(() => {
            fetchFlag = false;
          });
    };

    var getcouponFlag = false;
    const getXiaoHao = () => {
      xiaohaolist({
        // 改完再改回来
        gid: getQueryString("gid"),
        uid: getQueryString("uid"),
      }).then((response) => {
        if (response.data.code == 1) {
          state.subNameList = response.data.data || [];
          state.selectedItem = state.subNameList[0] || {};
          state.tempPosition = 0;
          if (state.subNameList.length > 0) {
            state.subNameList.forEach((item, index) => {
              item.status = index == 0 ? "1" : "0";
            });
          }
        } else {
          Toast(response.data.msg);
        }
        getcouponFlag = true;
        return Promise.all([fetchFlashCoupons(), onLoad()]);
      }).catch((error) => {
        Toast(error?.response?.data?.msg || "加载失败，请稍后重试");
        state.loading = false;
        state.refreshing = false;
      });
    };

    const switchXiaoHao = () => {
      state.show = true;
    };

    const onXiaoHaoSelected = (position) => {
      state.tempPosition = position;
      for (let i = 0; i < state.subNameList.length; i++) {
        if (i == position) {
          state.subNameList[i].status = "1";
        } else {
          state.subNameList[i].status = "0";
        }
      }
    };

    const onCancel = () => {
      state.show = false;
    };

    const onSure = () => {
      state.show = false;
      state.selectedItem = state.subNameList[state.tempPosition];
      pagecode = 1;
      state.coupons = [];
      state.finished = false;
      onLoad();
    };

    onActivated(() => {
      if (route.query.gid != state.oldId) {
        state.missPageFlag = false;
        state.oldId = route.query.gid;
        // 打开加载动画
        console.log("不是同一个游戏");
        state.coupons = [];
        state.flashCoupons = [];
        state.subNameList = [];
        state.selectedItem = {};
        state.finished = false;
        pagecode = 1;
        getcouponFlag = false;
        getXiaoHao();
      }
    });

    // // --------------------分页---------------------------------优惠券
    var pagecode = 1;
    var totalpage = 1;

    var requestFlag = false;
    const onLoad = () => {
      if (!getcouponFlag) {
        state.loading = false;
        return Promise.resolve();
      }

      // console.log('当前页数----------------', pagecode);
      if (requestFlag) {
        return Promise.resolve();
      }

      requestFlag = true;
      state.loading = true;

      return gameDeduction({
        gid: getQueryString("gid"),
        uid: getQueryString("uid"),
        pagecode: pagecode,
        xiaohao: state.selectedItem.username ? state.selectedItem.username : "",
      }).then((response) => {
        // console.log("分页返回的数据-----------", response.data);

        const data = response.data || {};
        totalpage = Number(data.total_page) || 1;
        state.show_sdkyk = data.show_sdkyk;
        state.user_yk = data.user_yk;
        state.coupons = state.coupons.concat(data.lists || []);
        // 去除id重复的数据
        var obj = {};
        state.coupons = state.coupons.reduce((cur, next) => {
          if (!obj[next.cid]) {
            obj[next.cid] = true;
            cur.push(next);
          }
          return cur;
        }, []);

        pagecode = Number(data.now_page) || pagecode;
        if (pagecode >= totalpage) {
          state.finished = true;
          return;
        }

        pagecode++;
      }).catch((error) => {
        Toast(error?.response?.data?.msg || "加载失败，请稍后重试");
      }).finally(() => {
        requestFlag = false;
        state.loading = false;
      });
    };

 const fetchFlashCoupons = () => {
      return couponFlashLists({
        uid: getQueryString("uid"),
        gid: getQueryString("gid"),
      }).then((response) => {
        state.flashCoupons = response.data?.data?.lists || [];
        state.url_fuliguan = response.data?.data?.url_fuliguan || "";
        console.log("flashCoupons = " ,state.flashCoupons);
      }).catch((error) => {
        // Toast(error?.response?.data?.msg || "抢购优惠券加载失败");
      });
    };

    let flashFetchFlag = false;

    const canReceiveFlashCoupon = (item) => {
      return (
         Number(item.remain_stock) > 0 &&
        item.is_get == "0" &&
        !flashFetchFlag && 
        item.button_enabled
      );
    };

    const flashCouponButtonText = (item) => {
      if (Number(item.remain_stock) <= 0) return "已抢光";
      if (item.is_get == "1") return "已领取";
      if (!item.button_enabled) return "已抢光";
      return "已抢光";
    };

    const receiveFlashCoupon = (item) => {
      if (!canReceiveFlashCoupon(item)) return;
      flashFetchFlag = true;
      getCouponFlash({
        uid: getQueryString("uid"),
        gid: getQueryString("gid"),
        activity_id: item.activity_id,
        imei: "",
      })
        .then((response) => {
          Toast(response.data.msg);
          if(response.data.code == 1){
            fetchFlashCoupons();
          }
        })
        .catch((error) => {
          Toast(error?.response?.data?.msg || "领取失败，请稍后重试");
        })
        .finally(() => {
          flashFetchFlag = false;
        });
    };

    const onRefresh = () => {
      pagecode = 1;
      state.coupons = [];
      state.flashCoupons = [];
      state.finished = false;
      state.loading = true;
      getcouponFlag = true;
      Promise.all([fetchFlashCoupons(), onLoad()]).finally(() => {
        state.refreshing = false;
        state.loading = false;
      });
    };

    const goMonthCard = () => {
      window.JsBridge.skipMouthCardActivity();
    };

    const goMyCoupon = () => {
      router.push({
        path: "/coupon/mycoupon",
      });
    };
    const openTips = () => {
      // console.log('788888')
      state.showTips = true;
    };
    const goUrl = (url)=>{
       window.location.href = url;
      //  window.JsBridge.skipAppWebActivity(url, "福利官");
    }
    return {
      state,
      receiveCoupon,
      getXiaoHao,
      onXiaoHaoSelected,
      onClickLeft,
      onCancel,
      switchXiaoHao,
      onSure,
      gettime,
      goMyCoupon,
      goMonthCard,
      canReceiveFlashCoupon,
      flashCouponButtonText,
      receiveFlashCoupon,
      onLoad,
      onRefresh,
      openTips,
      goUrl
    };
  },
};
</script>

<style scoped="scoped" lang="less">
.coupon-fuliguan img{
  width: 100%;
  margin-top: 16px;
}
.coupon-title {
  font-size: 24px;
  color: #999;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-box {
  background-color: #f7f8fa;
}

.detailswelfare-box {
  // height: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  padding: 0 32px;

  .top-box {
    display: flex;
    background: #fff;
    justify-content: space-between;
    height: 60px;
    align-items: center;
    border-radius: 16px;
    width: 686px;
    padding: 0 24px;

    p {
      &:nth-of-type(1) {
        color: #12cec7;
        margin-right: 31px;
        font-size: 24px;
      }

      &:nth-of-type(2) {
        color: #12cec7;
        margin-right: 31px;
        font-size: 24px;
      }

      &:nth-of-type(3) {
        color: #12cec7;
        margin-right: 31px;
        font-size: 24px;
      }
    }
  }
}

.van-list {
  padding-top: 16px;
}

.coupon-refresh {
  min-height: calc(100vh - 190px);
}

.van-cell {
  padding: 0;
  background-color: #f7f7f7;

  :deep(.van-cell__value) {
    display: flex;
    margin-bottom: 20px;
    height: 160px;
    background: url(../../../assets/game/yz_xq_quan_bj.png) no-repeat center top;
    background-size: 100% 100%;
  }
  :deep(.van-cell__value) > div {
    display: flex;
    margin-bottom: 20px;
    height: 160px;
  }

  .left {
    width: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 88px;
      height: 28px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .tips {
      width: 88px;
      height: 28px;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(../../../assets/game/coupon_get_bg.png);
      background-size: 100%;
      font-size: 18px;
      color: #fff;
      text-align: center;
      line-height: 28px;
    }

    p {
      &:nth-of-type(1) {
        &:nth-of-type(1) {
          color: #F34;
          font-size: 48px;
          font-weight: bold;

          span {
            font-size: 24px;
            margin-right: 2px;
          }
        }
      }

      &:nth-of-type(2) {
        color: #F34;
        font-size: 20px;
        line-height: 1.2;
      }
    }
  }

  .right {
    width: 100%;
    flex: 1;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;


    p {
      font-size: 20px;
      color: #707070;
      line-height: 1.8;
      .tipimg {
        width: 32px;
        height: 32px;
        margin-left: 4px;
      }
      &:nth-of-type(1) {
        font-size: 28px;
        color: #000;
        font-weight: 700;
        line-height: 40px;
        display: flex;
      }
    }

    & > div:nth-of-type(1) {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    div:nth-of-type(2) {
      display: flex;
      align-items: center;
    }

    .cardbtngray,
    .cardbtnnor {
      position: absolute;
      right: 0;
    }

    .cardbtnnor {
      width: 120px;
      height: 56px;
      background-color: #12cec7;
      border-radius: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 24px;
      margin-right: 32px;
    }

    .cardbtngray {
      width: 120px;
      height: 56px;
      background-color: #F4F5F8;
      border-radius: 48px;
      color: #727888;
      font-size: 24px;
      margin-right: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 24px;
      height: 24px;
      position: relative;
      top: 0;
      right: 0;
      z-index: 99;
    }
  }
}

.detailswelfare-box:deep(.van-popup) {
  background: none;
}

.popup-box {
  width: 628px;
  padding: 32px;
  text-align: center;
  border-radius: 20px;
  background: #fff;

  h3 {
    font-size: 32px;
    margin: 0 auto;
    margin-bottom: 52px;
  }

  .btn-box {
    display: flex;
    height: 50px;
    align-items: center;

    p {
      width: 50%;

      &:nth-of-type(1) {
        color: #999999;
      }

      &:nth-of-type(2) {
        color: #12cec7;
      }
    }
  }

  .subname-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f1f1f1;
    padding: 24px 20px;
    border-radius: 10px;
    margin: 20px 0;

    p:nth-child(1) {
      text-align: center;
      font-size: 28px;
    }

    img {
      width: 30px;
      height: 30px;
    }
  }
}


.splitTips {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 100px;
  font-size: 38px;
}
.splitTips h3 {
  color: #00d9c5;
}
.splitTips div {
  margin-top: 20px;
  color: #333;
  font-size: 28px;
  padding: 0 32px;
}
.splitTips div p {
  margin-top: 10px;
}

.splitTips button {
  margin-top: 40px;
  background-color: #2acbaf;
  border-radius: 198px;
  height: 88px;
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 32px;
  width: 562px;
}

.coupon-yk {
  width: 100%;
  height: 100%;
}
.coupon-yk img {
  width: 100%;
  margin-top: 24px;
}
</style>
